module.exports = __webpack_public_path__ + "media/proksee-viewer/images/fb-invert-colors-1beb1f98153e3396d652f956bf7ba9fb.png";